export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_STATUS = 'SET_STATUS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_DEVICE = 'SET_DEVICE'
export const SET_DEVICES = 'SET_DEVICES'
export const SET_PAIRING_INFO = 'SET_PAIRING_INFO'
export const SET_WO_PAIRING_INFO = 'SET_WO_PAIRING_INFO'
export const SET_CONNECTED_DEVICES = 'SET_CONNECTED_DEVICES'
export const SET_CURRENT_DEVICE = 'SET_CURRENT_DEVICE'
export const CLEAR_DEVICES = 'CLEAR_DEVICES'
export const SET_SERVER_PROFILES = 'SET_SERVER_PROFILES'



// WEBPACK FOOTER //
// ./src/store/modules/admin/devices/types.js